import type { Theme } from '../contexts/ThemeContext';

// Chart.js can't consume Tailwind classes, so the chart palette lives here and
// mirrors the semantic tokens in index.css. Keep the two in sync.
export const chartTheme = (theme: Theme) =>
  theme === 'dark'
    ? {
        text: '#ffffff',
        grid: '#374151',
        surface: '#222244',
        series1: '#eab308',
        series1Fill: 'rgba(234, 179, 8, 0.6)',
        series2: '#60a5fa',
        series2Fill: 'rgba(96, 165, 250, 0.6)',
      }
    : {
        text: '#0f172a',
        grid: '#cbd5e1',
        surface: '#ffffff',
        series1: '#854d0e',
        series1Fill: 'rgba(133, 77, 14, 0.6)',
        series2: '#1d4ed8',
        series2Fill: 'rgba(29, 78, 216, 0.6)',
      };
